// Local-only progress-photo storage (IndexedDB). Photos live on THIS device only for now —
// nothing is uploaded to the server. Kept behind a small add/list/get/delete surface so the
// backend can later swap to signed cloud URLs (R2/Bunny) without touching the camera/screen code.

const DB_NAME = "wt-progress";
const STORE = "photos";

let dbPromise = null;
function db() {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      const d = req.result;
      if (!d.objectStoreNames.contains(STORE)) {
        const os = d.createObjectStore(STORE, { keyPath: "id", autoIncrement: true });
        os.createIndex("user_id", "user_id", { unique: false });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return dbPromise;
}

function store(mode) {
  return db().then((d) => d.transaction(STORE, mode).objectStore(STORE));
}
function wrap(request) {
  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

/** Save a captured photo blob. Returns the stored record (incl. its new id). */
export async function addPhoto(userId, blob, meta = {}) {
  const os = await store("readwrite");
  const record = { user_id: userId, blob, created_at: Date.now(), ...meta };
  record.id = await wrap(os.add(record));
  return record;
}

/** All photos for a user, newest first. */
export async function listPhotos(userId) {
  const os = await store("readonly");
  const all = await wrap(os.index("user_id").getAll(userId));
  return all.sort((a, b) => b.created_at - a.created_at);
}

export async function deletePhoto(id) {
  const os = await store("readwrite");
  await wrap(os.delete(id));
}

/** Best-effort device storage usage (bytes), for a gentle "stored on this device" hint. */
export async function estimateUsage() {
  try {
    if (navigator.storage?.estimate) return await navigator.storage.estimate();
  } catch {}
  return null;
}
